import Swiper, { Navigation, Pagination, EffectFade } from 'swiper';
// screenCheck Jquery
import screencheck from './screenCheck'; 
// screencheck();

function joinMobileSlider() {

    // var screencheck = function(mediasize){
    //     if (typeof window.matchMedia !== "undefined"){
    //         var screensize = window.matchMedia("(max-width:"+ mediasize+"px)");
    //         if( screensize.matches ) {
    //             return true;
    //         }else {
    //             return false;
    //         }
    //     } else { 
    //         if( $winW() <=  mediasize ) {
    //             return true;
    //         }else {
    //             return false;
    //         }
    //     }
    // };

    
    if($(".join-slider").length) {
    var productGallerySlider;
    $(window).on('resize', function(){
        if (screencheck(767)) {
            if (productGallerySlider) return;
            else productGallerySlider = new Swiper('.join-slider', {
            modules: [Pagination ],
            slidesPerView: 1,
            spaceBetween: 0,
            simulateTouch: false,
            draggable: true,
            clickable: true,
            watchSlidesVisibility: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                320: {
                  slidesPerView: 1,
                  spaceBetween: 5
                },
                567: {
                  slidesPerView: 2,
                  spaceBetween: 5
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 5
                }
              }
            });
        } else {
            if (productGallerySlider) {
                productGallerySlider.destroy();
                productGallerySlider = undefined;
            }
        }
    }).resize(); 
    } 

    
}

export default joinMobileSlider;


